
import { SimulationNodeDatum, SimulationLinkDatum } from 'd3';

export enum AtlasCategory {
  THREAT = 'Minaccia',
  DEFENSE = 'Difesa',
  AI_MODEL = 'Modello AI',
  REGULATION = 'Normativa',
  CONCEPT = 'Concetto'
}

export interface AtlasEntry {
  id: string;
  title: string;
  category: AtlasCategory;
  shortDescription: string;
  tags: string[];
  severity?: 'Low' | 'Medium' | 'High' | 'Critical';
}

export interface GraphNode extends SimulationNodeDatum {
  id: string;
  group: number;
  val: number; // influence size
  label: string;
}

export interface GraphLink extends SimulationLinkDatum<GraphNode> {
  source: string | GraphNode;
  target: string | GraphNode;
  value: number;
}

export interface BlogPost {
  id: number;
  category: string;
  title: string;
  date: string;
  excerpt: string;
  author: string;
  readTime: string;
  content: string; // Changed from string[] to string to support WP HTML
}

// SYSTEM LOGGING
export interface SystemLog {
  timestamp: string;
  level: 'INFO' | 'WARN' | 'ERROR' | 'ACCESS';
  module: string;
  message: string;
  metadata?: any;
}

// FILE SYSTEM STRUCTURE
export interface VirtualDirectory {
  name: string;
  files: AtlasEntry[];
}

// --- ALMANACCO TYPES ---

export type AlmanacCategory = 'INCIDENT' | 'AI_MILESTONE' | 'METHOD' | 'REGULATION';

export interface AlmanacEvent {
  id: string;
  date: string; // YYYY-MM-DD
  year: number;
  title: string;
  description: string;
  category: AlmanacCategory;
  source: 'CSIS' | 'MITRE' | 'AI_WATCH' | 'CARNEGIE' | 'EPOCH_AI' | 'INTERNAL';
  confidenceScore: number; // 0.0 to 1.0 (Based on source authority)
  impactLevel: 'Low' | 'Medium' | 'High' | 'Critical';
  tags: string[];
  relatedEvents?: string[]; // IDs of connected events
}
